import React from 'react';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import immutableToJS from 'utils/immutableToJS';

import { userSelector } from 'features/authentication/redux/selectors';

import {
  clearCaseRecipients,
  loadCaseNotes,
  loadCaseRecipients,
  postCaseNote,
  setCaseNotes,
  updateCaseNote,
} from 'redux/cases/actions';
import {
  setComponentExpanded as setComponentExpandedAction,
  updateScrollToUnreadNote,
} from 'redux/ui/actions';
import {
  caseNotesSelector,
  caseRecipientsSelector,
  currentCaseSelector,
} from 'redux/cases/selectors';
import {
  actionBarItemClickedSelector,
  componentsExpandedSelector,
  scrollToUnreadNoteSelector,
} from 'redux/ui/selectors';

import NotesPropTypes from './PropTypes';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = NotesPropTypes;

  Container.defaultProps = {
    actionBarItemClicked: {},
    info: {},
    notes: {
      requesting: false,
      error: null,
      data: [],
    },
    availableRecipients: {
      requesting: false,
      error: null,
      data: [],
    },
    scrollToUnreadNote: false,
  };

  function mapStateToProps(state, ownProps) {
    return {
      actionBarItemClicked: actionBarItemClickedSelector(state),
      currentUser: userSelector(state),
      info: ownProps.caseInfo || currentCaseSelector(state),
      notes: caseNotesSelector(state),
      availableRecipients: caseRecipientsSelector(state),
      componentsExpanded: componentsExpandedSelector(state),
      scrollToUnreadNote: scrollToUnreadNoteSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      clearAvailableRecipients: () => dispatch(clearCaseRecipients()),
      loadNotes: caseId => dispatch(loadCaseNotes({ caseId })),
      loadAvailableRecipients: caseId => dispatch(loadCaseRecipients({ caseId })),
      postNote: payload => dispatch(postCaseNote(payload)),
      setNotes: caseNotes => dispatch(setCaseNotes(caseNotes)),
      updateNote: params => dispatch(updateCaseNote(params)),
      setComponentExpanded: (expandKey, expanded) =>
        dispatch(setComponentExpandedAction({ expandKey, expanded })),
      updateScrollToUnreadNote: bool => dispatch(updateScrollToUnreadNote(bool)),
    };
  }

  return compose(
    setDisplayName('CaseNotesContainer'),
    connect(mapStateToProps, mapDispatchToProps),
    immutableToJS,
  )(Container);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/CaseNotesContainer.js